import { strings } from "../i18n/strings.es-AR.js";
import { online } from "../state/store.js";

export function OfflineBanner() {
  if (online.value) return null;
  return (
    <div class="bg-amber-100 px-4 py-2 text-xs text-amber-800">
      <div class="chat-col text-center">{strings.offline}</div>
    </div>
  );
}
